import React from 'react';
import './expand_arrow.css';

type ExpandArrowProps = {
  expanded: boolean;
  size?: number; // px
  stroke?: number; // SVG stroke width
  className?: string;
  title?: string; // for screen readers if the button doesn't already convey state
};

export default function ExpandArrow({
  expanded,
  size = 18,
  stroke = 2,
  className = '',
  title = 'Expand',
}: ExpandArrowProps) {
  return (
    <svg
      className={`expand-arrow ${expanded ? 'is-open' : ''} ${className}`}
      viewBox="0 0 24 24"
      aria-hidden={true}
      role="img"
      style={
        {
          // CSS variables for easy theming
          ['--ea-size' as any]: `${size}px`,
          ['--ea-stroke' as any]: stroke,
        } as React.CSSProperties
      }
    >
      {/* Right-pointing chevron; we rotate the whole SVG when open */}
      <polyline points="9 6 15 12 9 18" vectorEffect="non-scaling-stroke" />
      <title>{title}</title>
    </svg>
  );
}
